
import isTouchDevice from "../lib/is-mobile";

const lexique = () => {

    document.addEventListener('DOMContentLoaded', function () {

        let words = document.querySelectorAll('.lexique__letters-content-item-word');

        if(words) {

            const setToggleLexique = () => {
                words.forEach((word) => {
                    if (isTouchDevice() && window.matchMedia("(min-width: 1439px)").matches) {
                        console.log(isTouchDevice())
                            word.addEventListener("click", function () {
                                if (word.classList.contains('active')) {
                                    word.classList.remove('active')
                                } else {
                                    word.classList.add('active')
                                }
                            })
                        
                    } else {
                        word.addEventListener("mouseover", () => {
                            word.classList.add("active");
                          });
                  
                          word.addEventListener("mouseleave", () => {
                            word.classList.remove("active");
                          });
                          word.addEventListener("click", () => {
                            words.classList.remove("active");
                            word.classList.add("active");
                          });
                  
                    }
                })
            }
            setToggleLexique();

            window.addEventListener('resize', setToggleLexique());

        }

    });
    
    }
    
    export default lexique;